var _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0185,
    cy: 16.0185,
    r: 14.2411,
    fill: "#E8FFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H19V9H18V10H14V9H13V10H11C10.7349 10.0003 10.4807 10.1057 10.2932 10.2932C10.1057 10.4807 10.0003 10.7349 10 11V21C10.0003 21.2651 10.1057 21.5193 10.2932 21.7068C10.4807 21.8943 10.7349 21.9997 11 22H21C21.2651 21.9997 21.5193 21.8943 21.7068 21.7068C21.8943 21.5193 21.9997 21.2651 22 21V11C21.9997 10.7349 21.8943 10.4807 21.7068 10.2932C21.5193 10.1057 21.2651 10.0003 21 10V10ZM11 11H13V12H14V11H18V12H19V11H21V13H11V11ZM11 14H13.5V17H11V14ZM17.5 21H14.5V18H17.5V21ZM17.5 17H14.5V14H17.5V17ZM18.5 21V18H21L21.0005 21H18.5Z",
    fill: "#3BC98D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3333,
    stroke: "#3BC98D",
    strokeWidth: 1.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleCall);
export default __webpack_public_path__ + "static/media/schedule-call.ab4f58f324c3d6f9d9c21697a343a001.svg";
export { ForwardRef as ReactComponent };